import { Redirect, Route, Switch } from "react-router-dom";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { WSQueries } from "../../query/WSQuery";
import {
  BULK_IMPORT_CONTRACTORS_BATCH_DETAILS,
  BULK_IMPORT_CONTRACTORS_BATCH_EVENT_HISTORY,
  BULK_IMPORT_CONTRACTORS_START,
  BULK_IMPORTS_ROOT_PATH,
  PATH_IMPORT_PAYABLES_BATCH,
  PATH_IMPORT_PAYABLES_BATCH_HISTORY,
  PATH_IMPORT_PAYABLES_START
} from "./paths";
import { RouteImportPayableBatchDetails } from "./routes/RouteImportPayableBatchDetails";
import { RouteImportPayableBatchEventHistory } from "./routes/RouteImportPayableBatchEventHistory";
import { RouteImportPayablesStart } from "./routes/RouteImportPayablesStart";
import { RouteImportContractorsBatchDetails } from "./routes/RouteImportContractorsBatchDetails";
import { RouteImportContractorBatchEventHistory } from "./routes/RouteImportContractorBatchEventHistory";
import { RouteImportContractorsStart } from "./routes/RouteImportContractorsStart";
import { BulkImports } from "./routes/BulkImports";

export const BulkImportsIndex: React.FC = () => {
  const queryFeatureFlags = useQueryFeatureFlags();
  return (
    <WSQueries queries={{ queryFeatureFlags }}>
      {({ queryFeatureFlagsData: featureFlags }) => {
        return (
          <Switch>
            {/* Bulk import contractors pages */}
            <Route
              path={BULK_IMPORT_CONTRACTORS_START}
              component={RouteImportContractorsStart}
            />
            {featureFlags.newBulkImporterUI && (
              <Route
                path={BULK_IMPORT_CONTRACTORS_BATCH_EVENT_HISTORY}
                component={RouteImportContractorBatchEventHistory}
              />
            )}
            {featureFlags.newBulkImporterUI && (
              <Route
                path={BULK_IMPORT_CONTRACTORS_BATCH_DETAILS}
                component={RouteImportContractorsBatchDetails}
              />
            )}
            {/* Bulk import payables pages */}
            <Route
              path={PATH_IMPORT_PAYABLES_START}
              component={RouteImportPayablesStart}
            />
            <Route
              path={PATH_IMPORT_PAYABLES_BATCH_HISTORY}
              component={RouteImportPayableBatchEventHistory}
            />
            <Route
              path={PATH_IMPORT_PAYABLES_BATCH}
              component={RouteImportPayableBatchDetails}
            />
            <Route path={BULK_IMPORTS_ROOT_PATH} component={BulkImports} />
            <Redirect from="*" to={BULK_IMPORTS_ROOT_PATH} />
          </Switch>
        );
      }}
    </WSQueries>
  );
};
